import * as React from 'react';
import { Link } from '../Link';
import { SubtitleLayout } from '../SubtitleLayout';
import * as styles from './PhoneSmsConfirmationInfo.css';
import { formatPhoneWithSpecialChars } from '../../utils/formatString';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function PhoneSmsConfirmationInfo(_ref) {
  var phone = _ref.phone,
    onEditPhoneClick = _ref.onEditPhoneClick;
  return /*#__PURE__*/_jsxs(SubtitleLayout, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: ["\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0435\u0433\u043E\xA0\u043D\u0430\xA0", formatPhoneWithSpecialChars(phone)]
    }), onEditPhoneClick && /*#__PURE__*/_jsx("div", {
      className: styles['link'],
      children: /*#__PURE__*/_jsx(Link, {
        href: "#",
        onClick: onEditPhoneClick,
        children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440"
      })
    })]
  });
}